import { FLEETS_FILTERS_SECTIONS } from './fleets-filters-sections';
import { PROJECTS_FILTERS_SECTIONS } from './projects-filters-sections';
import { TENDERS_NEW_FILTERS_SECTIONS } from './tenders-new-filters-sections';
import type { TDataSourceDefinitionPresetSectionsCatalog } from './interfaces';

export const FEATURE_FILTERS_SECTIONS: TDataSourceDefinitionPresetSectionsCatalog = {
  projects: PROJECTS_FILTERS_SECTIONS,
  fleets: FLEETS_FILTERS_SECTIONS,
  tenders: TENDERS_NEW_FILTERS_SECTIONS,
  'tenders-new': TENDERS_NEW_FILTERS_SECTIONS,
  'tenders-info': TENDERS_NEW_FILTERS_SECTIONS,
};
